export interface SettingStateInterface {
  googleMapsApiKey: string | null;
  allowedFileUploadExtensions: string | null;
  maxFileUploadSizeInMegaBytes: number | null;
  maxAdditionalConsumerUsers: number | null;
  fullAccessCountryCodes: string | null;
  consumerSupportEmail: string | null;
  consumerSupportPhone: string | null;
  consumerPartsEmail: string | null; 
  consumerServiceEmail: string | null;
  initialized: boolean;
  company: string | null; // TODO: Replace this with enum?
  companyDisplayName: string | null;
  companyAddress : string | null;
  mondayThruThursdaySupportHours : string | null;
  fridaySupportHours : string | null;
  
  platform: string | null; // ios | android | web
}

function state(): SettingStateInterface {
  return {
    googleMapsApiKey: null,
    allowedFileUploadExtensions: null,
    maxFileUploadSizeInMegaBytes: null,
    maxAdditionalConsumerUsers: null,
    fullAccessCountryCodes: null,
    consumerSupportEmail: null,
    consumerSupportPhone: null,
    consumerPartsEmail: null,
    consumerServiceEmail: null,
    initialized: false,
    company: null,
    companyDisplayName: null,
    companyAddress : null,
    mondayThruThursdaySupportHours :  null,
    fridaySupportHours : null,
    platform: null
  }
}

export default state;
